<i18n src="@/lang/table" />
<i18n src="@/lang/actions" />
<i18n src="@/lang/rules" />
<template>
  <el-form :model="model" :rules="rules" label-width="150px">
    <el-form-item :label="$t('table.service_uri')" prop="service_uri">
      <el-input
        size="small"
        v-model="model.service_uri"
        @blur="
          !model.service_uri ||
            (model.service_uri = model.service_uri.replace(/[\/]+$/, ''))
        "
        @change="handleCheckURI"
      >
        <template slot="prepend">https://</template>
        <template slot="append">
          <el-button
            :icon="verifiedUri ? 'el-icon-check' : 'el-icon-view'"
            :style="{ color: verifiedUri ? 'green' : null }"
            @click="handleCheckURI"
          />
        </template>
      </el-input>
    </el-form-item>
    <el-form-item :label="$t('table.code')" prop="code">
      <el-input size="small" v-model="model.code" disabled />
    </el-form-item>
    <el-form-item :label="$t('table.enabled')" prop="enabled">
      <el-switch v-model="model.enabled" />
    </el-form-item>

    <div class="form-actions">
      <el-button
        size="small"
        type="primary"
        v-t="buttonSaveCaption"
        :disabled="disableSave"
        @click="handleSave"
      />
      <el-button
        size="small"
        v-t="'actions.cancel'"
        @click="edit_mode = false"
      />
    </div>
  </el-form>
</template>

<script>
import SharedWidgets from "../../../store/classes/SharedWidgets";

export default {
  name: "widgetEdit",
  props: {
    widget: {
      type: Object,
      default: () => ({})
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: new SharedWidgets(JSON.parse(JSON.stringify(this.widget))),
      rules: {
        service_uri: [
          {
            required: true,
            message: this.$t("rules.service_uri.require"),
            trigger: "change"
          }
        ]
      },
      processing_save: false
    };
  },
  watch: {
    "model.service_uri"(v) {
      if (this.verifiedUri) {
        this.$delete(this.model, "widgetsJSON");
        this.$delete(this.model, "manifestJSON");
        !this.model.code || (this.model.code = "");
      }
      this.model.service_uri = v.replace(/^http[s]{0,1}:\/\//, "");
    }
  },
  methods: {
    handleKeyup() {
      this.$log("keyup", arguments);
    },
    handleSave() {
      if (this.processing_save) {
        return;
      }
      this.processing_save = true;
      this.model
        .save()
        .then(() => {
          if (this.model.uuid) {
            this.$emit("update:widget", this.model);
            this.edit_mode = false;
          }
        })
        .catch(e => {
          this.$log("Catched exeption for saving widget");
        })
        .then(e => {
          this.processing_save = false;
        });
    },
    handleCheckURI() {
      this.model
        .checkUri()
        .then(() => {
          let h = this.$createElement;
          let widget_code = null;
          let list = Object.keys(this.model.widgetsJSON);
          this.$msgbox({
            title: "Message",
            message: h(require("./multi_widget_form").default, {
              props: { data: list },
              on: {
                change: v => {
                  widget_code = v;
                }
              }
            }),
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",

            beforeClose: (action, instance, done) => {
              this.$log("TYT", action, instance);
              if (action === "confirm") {
                done();
              } else {
                done();
              }
            }
          })
            .then(action => {
              this.$message({
                type: "info",
                message: "action: " + action
              });
              if (widget_code) {
                this.$log(this, this.model);
                this.$set(this.model, "code", widget_code);
                this.$set(
                  this.model,
                  "path",
                  this.model.widgetsJSON[widget_code].path
                );
                this.$set(
                  this.model,
                  "front_uri",
                  this.model.widgetsJSON[widget_code].uri
                );
              }
            })
            .catch(e => {
              this.$log(e);
            });
        })
        .catch(e => {
          this.$log(e);
        });
    }
  },
  computed: {
    edit_mode: {
      get: function() {
        return this.editMode;
      },
      set: function(v) {
        this.$emit("update:editMode", v);
      }
    },
    verifiedUri() {
      return this.model.widgetsJSON && true;
    },
    disableSave() {
      return (
        !this.model.code ||
        !!this.$store.state.shared_widgets_list.data.filter(v => {
          return v.uuid !== this.model.uuid && v.code === this.model.code;
        }).length
      );
    },
    buttonSaveCaption() {
      return "actions." + (this.model.uuid ? "update" : "save");
    }
  }
};
</script>

<style scoped lang="stylus">
.form-actions
    display flex
    justify-content flex-end
    align-items center
</style>
